import { TranslationSet } from './en';

// TODO: translate values from English
export const hi: TranslationSet = {
  '(From Now)': '(अभी से)',
  '(From Scheduled)': '(अनुसूचित से)',
  '{amount} Off. Expires: {expires}.': '{amount} बंद। समाप्ति: {expires}.',
  'A detailed report showing each activity and how long a technician or staff member took between and at each site with a total time at the site.': 'प्रत्येक गतिविधि को दर्शाने वाली एक विस्तृत रिपोर्ट और एक तकनीशियन या स्टाफ सदस्य ने साइट पर कुल समय के साथ प्रत्येक साइट के बीच और कितना समय बिताया।',
  'A service type with inspection enabled will show up in the "to inspect" list on mobile. It is also used in reporting.': 'निरीक्षण सक्षम होने पर एक सेवा प्रकार मोबाइल पर "निरीक्षण करने के लिए" सूची में दिखाई देगा। इसका उपयोग रिपोर्टिंग में भी किया जाता है.',
  'Accept Invite': 'आमंत्रण स्वीकार करें',
  'Add Condition': 'शर्त जोड़ें',
  'Add deficiencies to the equipment type': 'उपकरण प्रकार में कमियाँ जोड़ें',
  'Add Deficiency': 'कमी जोड़ें',
  'Add Equipment Field': 'उपकरण फ़ील्ड जोड़ें',
  'Add Equipment Type': 'उपकरण प्रकार जोड़ें',
  'Add Equipment': 'उपकरण जोड़ें',
  'Add Floor Plan': 'फ़्लोर प्लान जोड़ें',
  'Add history by clicking the plus in the top right or by performing a service.': 'शीर्ष दाईं ओर प्लस पर क्लिक करके या कोई सेवा निष्पादित करके इतिहास जोड़ें।',
  'Add History': 'इतिहास जोड़ें',
  'Add Model Field': 'मॉडल फ़ील्ड जोड़ें',
  'Add Model': 'मॉडल जोड़ें',
  'Add Option': 'विकल्प जोड़ें',
  'Add Question': 'प्रश्न जोड़ें',
  'Add questions using the plus icon in the top right': 'ऊपर दाईं ओर प्लस आइकन का उपयोग करके प्रश्न जोड़ें',
  'Add service month categories in settings > service month categories. Service months allow you to keep different types of equipment in selected months for each location. Example: Alarms in May and October and Extinguishers in December.': 'सेटिंग > सेवा माह श्रेणियों में सेवा माह श्रेणियां जोड़ें। सेवा माह आपको प्रत्येक स्थान के लिए चयनित महीनों में विभिन्न प्रकार के उपकरण रखने की अनुमति देते हैं। उदाहरण: मई और अक्टूबर में अलार्म और दिसंबर में बुझाने वाले उपकरण।',
  'Add Service Month Category': 'सेवा माह श्रेणी जोड़ें',
  'Add Service Type': 'सेवा प्रकार जोड़ें',
  'Add service types in the settings': 'सेटिंग्स में सेवा प्रकार जोड़ें',
  'Add service types using the plus icon in the top right': 'शीर्ष दाईं ओर प्लस आइकन का उपयोग करके सेवा प्रकार जोड़ें',
  'Add services to the equipment type': 'उपकरण प्रकार में सेवाएँ जोड़ें',
  'Add site Field': 'साइट फ़ील्ड जोड़ें',
  'Add Site Override': 'साइट ओवरराइड जोड़ें',
  'Add Site Type': 'साइट प्रकार जोड़ें',
  'Add Site': 'साइट जोड़ें',
  'Add Sites': 'साइटें जोड़ें',
  'Add User': 'उपयोगकर्ता जोड़ें',
  'Add your own fields in Settings > Custom Fields > Site Fields': 'सेटिंग्स > कस्टम फ़ील्ड्स > साइट फ़ील्ड्स में अपने स्वयं के फ़ील्ड जोड़ें',
  'Add': 'जोड़ें',
  'Adding': 'जोड़ना',
  'Address': 'पता',
  'Advance from Now': 'अभी से आगे बढ़ें',
  'Advance from Scheduled': 'अनुसूचित से अग्रिम',
  'Agree': 'सहमत',
  'All Sites Scheduled!': 'सभी साइटें शेड्यूल की गईं!',
  'All': 'सब',
  'Already have an account? Login': 'क्या आपके पास पहले से ही एक खाता है? लॉग इन करें',
  'An error happened while syncing': 'समन्वयन करते समय एक त्रुटि हुई',
  'April': 'अप्रैल',
  'August': 'अगस्त',
  'Back': 'वापस',
  'Billing Portal': 'बिलिंग पोर्टल',
  'Building Reports': 'बिल्डिंग रिपोर्ट',
  'Cancel Plan': 'योजना रद्द करें',
  'Cancel Subscription': 'सदस्यता रद्द करें',
  'Cancel': 'रद्द करें',
  'Change Model Fields': 'मॉडल फ़ील्ड बदलें',
  'Change Password': 'पासवर्ड बदलें',
  'Checklist Information': 'चेकलिस्ट सूचना',
  'Checklist Question': 'चेकलिस्ट प्रश्न',
  'Checklist': 'चेकलिस्ट',
  'Choose File': 'फ़ाइल चुनें',
  'City': 'शहर',
  'Clear All Data': 'सभी डेटा साफ़ करें',
  'Clear': 'स्पष्ट',
  'Click or tap to add location': 'स्थान जोड़ने के लिए क्लिक करें या टैप करें',
  'Close': 'बंद करें',
  'Company-Wide Reports': 'कंपनी-व्यापी रिपोर्टें',
  'Conditions': 'शर्तें',
  'Contact': 'संपर्क करें',
  'Copy Barcode': 'बारकोड कॉपी करें',
  'Could not access': 'पहुँच नहीं सक���',
  'Could not find equipment with the scanned barcode': 'स्कैन किए गए बारकोड वाले उपकरण नहीं मिल सके',
  'Could Not Service': 'सेवा नहीं हो सकी',
  'Create': 'बनाएँ',
  'Creating Your Account': 'अपना खाता बनाना',
  'Credentials are not valid': 'क्रेड���ंशियल मान्य नहीं हैं',
  'CSV': 'सीएसवी',
  'Custom Equipment Fields': 'कस्टम उपकरण फ़ील्ड',
  'Custom Fields': 'कस्टम फ़ील्ड',
  'Custom Model Fields': 'कस्टम मॉडल फ़ील्ड',
  'Custom site Fields': 'कस्टम साइट फ़ील्ड',
  'Date': 'दिनांक',
  'Debug': 'डीबग करें',
  'December': 'दिसंबर',
  'Deficiencies': 'कमियाँ',
  'Deficiency Report': 'कमी रिपोर्ट',
  'Deficiency': 'कमी',
  'Delete Equipment Field?': 'उपकरण फ़ील्ड हटाएँ?',
  'Delete Equipment Type?': 'उपकरण प्रकार हटाएँ?',
  'Delete Equipment Type': 'उपकरण प्रकार हटाएँ',
  'Delete Equipment?': 'उपकरण हटाएँ?',
  'Delete Equipment': 'उपकरण हटाएँ',
  'Delete Floor Plan?': 'फ़्लोर प्लान हटाएँ?',
  'Delete Model Field?': 'मॉडल फ़ील्ड हटाएं?',
  'Delete Model?': 'मॉडल हटाएं?',
  'Delete Model': 'मॉडल हटाएँ',
  'Delete Override': 'ओवरराइड हटाएँ',
  'Delete Question?': 'प्रश्न हटाएं?',
  'Delete Question': 'प्रश्न हटाएँ',
  'Delete Record?': 'रिकॉर्ड हटाएं?',
  'Delete Service Month?': 'सेवा माह हटाएँ?',
  'Delete Service Type?': 'सेवा प्रकार हटाएँ?',
  'Delete Site Field?': 'साइट फ़ील्ड हटाएं?',
  'Delete Site Type?': 'साइट प्रकार हटाएँ?',
  'Delete Site?': 'साइट हटाएं?',
  'Delete Site': 'साइट हटाएँ',
  'Delete User?': 'उपयोगकर्ता हटाएं?',
  'Delete User': 'उपयोगकर्ता हटाएँ',
  'Delete': 'हटाएँ',
  'Deleted Equipment Field': 'हटाया गया उपकरण फ़ील्ड',
  'Deleted Equipment': 'हटाए गए उपकरण',
  'Deleted Floor Plan': 'हटाया गया फ़्लोर प्लान',
  'Deleted Model Field': 'हटाया गया मॉडल फ़ील्ड',
  'Deleted Record': 'रिकार्ड हटा दिया गया',
  'Deleted Service Month': 'हटाया गया सेवा माह',
  'Deleted Service Type': 'हटाया गया सेवा प्रकार',
  'Deleted Site Field': 'हटाया गया साइट फ़ील्ड',
  'Deleted Site Type': 'हटाया गया साइट प्रकार',
  'Detailed': 'विस्तृत',
  'Did not want done': 'नहीं करना चाहता था',
  'Done by others': 'दूसरों द्वारा किया गया',
  'Don\'t have an account? Sign Up': 'कोई खाता नहीं है? साइन अप करें',
  'Done': 'हो गया',
  'Edit Dates': 'तिथिया�� संपादित करें',
  'Edit Equipment': 'उपकरण संपादित करें',
  'Edit': 'संपादित करें',
  'Email is not valid': 'ईमेल मान्य नहीं है',
  'End Date': 'समाप्ति तिथि',
  'Enter your email address': 'अपना ईमेल पता दर्ज करें',
  'Equipment already has this barcode': 'उपकरण में यह बारकोड पहले से ही मौजूद है',
  'Equipment can be anything from a fire extinguisher to a treadmill. Set up equipment types in settings > equipment types.': 'उपकरण अग्निशामक यंत्र से लेकर ट्रेडमिल तक कुछ भी हो सकता है। सेटिंग्स > उपकरण प्रकार में उपकरण प्रकार सेट करें',
  'Equipment Deleted': 'उपकरण नष्ट कर दिया गया',
  'Equipment Due Consolidated Report': 'उपकरण देय समेकित रिपोर्ट',
  'Equipment Due Report': 'उपकरण देय रिपोर्ट',
  'Equipment Field Information': 'उपकरण क्षेत्र की जानकारी',
  'Equipment fields allow you to add different additional fields on the equipment type, such as "Voltage" or "Km".': 'उपकरण फ़ील्ड आपको उपकरण प्रकार पर विभिन्न अतिरिक्त फ़ील्ड जोड़ने की अनुमति देते हैं, जैसे "वोल्टेज" या "किमी"।',
  'Equipment Fields': 'उपकरण क्षेत्र',
  'Equipment for a site with all scheduled services.': 'सभी अनुसूचित सेवाओं वाली साइट के लिए उपकरण।',
  'Equipment Options': 'उपकरण विकल्प',
  'Equipment Report': 'उपकरण रिपोर्ट',
  'Equipment Service Report': 'उपकरण सेवा रिपोर्ट',
  'Equipment SKU': 'उपकरण SKU',
  'Equipment Type Deleted': 'उपकरण प्रकार हटाया गया',
  'Equipment Type': 'उपकरण प्रकार',
  'Equipment types quickly add inspection and service definitions to equipment when a model containing it is selected. Examples: Fire Extinguisher, Treadmill, Truck': 'जब उपकरण वाले मॉडल का चयन किया जाता है तो उपकरण प्रकार उपकरण में निरीक्षण और सेवा परिभाषाएँ ���ुरंत जोड़ देते हैं। उदाहरण: अग्निशामक यंत्र, ट्रेडमिल, ट्रक',
  'Equipment Types': 'उपकरण के प्रकार',
  'Equipment': 'उपकरण',
  'Export Billing Data': 'बिलिंग डेटा निर्यात करें',
  'Export Data': 'डेटा निर्यात करें',
  'Export': 'निर्यात करें',
  'Failed to load organization.': 'संगठन लोड करने में विफल.',
  'Failed to save the organization.': 'संगठन को बचाने में विफल.',
  'February': 'फ़रवरी',
  'Fill out the options below to prepare your report.': 'अपनी रिपोर्ट तैयार करने के लिए नीचे दिए गए विकल्प भरें।',
  'Filter By': 'द्वारा फ़िल्टर करें',
  'FlameTask Basic Subscription': 'फ्लेमटास्क बेसिक सदस्यता',
  'FlameTask Enterprise Subscription': 'फ्लेमटास्क एंटरप्राइज सदस्यता',
  'FlameTask Pro Subscription': 'फ्लेमटास्क प्रो सदस्यता',
  'Floor Plan Location': 'तल योजना स्थान',
  'Floor Plan': 'तल योजना',
  'Floor Plans': 'तल योजनाएं',
  'Force Error': 'बलपूर्वक त्रुटि',
  'Forgot Password': 'पासवर्ड भूल गए',
  'Generate': 'उत्पन्न करें',
  'Hide "added" history records': '"जोड़े गए" इतिहास रिकॉर्ड छिपाएँ',
  'Hide Advanced': 'उन्नत छिपाएँ',
  'History': 'इतिहास',
  'How long a user spent at a site with time between actions.': 'किसी उपयोगकर्ता ने गतिविधियों के बीच समय के साथ साइट पर कितना समय बिताया।',
  'If this email matched an account, a link was sent to reset your password.': 'यदि यह ईमेल किसी खाते से मेल खाता है, तो आपका पासवर्ड रीसेट करने के लिए एक लिंक भेजा गया था।',
  'Import Data': 'डेटा आयात करें',
  'Import': 'आयात करें',
  'Inspection Due': 'निरीक्षण देय',
  'Inspection Report': 'निरीक्षण रिपोर्ट',
  'Inspection': 'निरीक्षण',
  'Inspections are up to date': 'निरीक्षण अद्यतन हैं',
  'January': 'जनवरी',
  'July': 'जुलाई',
  'June': 'जून',
  'Leave': 'छोड़ो',
  'List of all equipment at the site with options to show services and filtering based on due service and/or inspection.': 'उचित सेवा और/या निरीक्षण के आधार पर सेवाएं दिखाने और फ़िल्टर करने के विकल्पों के साथ साइट पर सभी उपकरणों की सूची।',
  'List of all sites with their information. Options to filter by status and service month to find which sites are serviced in a specific month.': 'सभी साइटों की सूची उनकी जानकारी के साथ। यह पता लगाने के लिए कि किसी विशिष्ट माह में किन साइटों पर सेवा दी जाती है, स्थिति और सेवा माह के आधार पर फ़िल्टर करने के विकल्प।',
  'List of equipment and deficiencies at the site, filtered by equipment with deficiencies that have a date opened and no closed date.': 'साइट पर उपकरण और कमियों की सूची, कमियों वाले उपकरण द्वारा फ़िल्टर की गई जिसमें खुलने की तारीख है और बंद होने की कोई तारीख नहीं है।',
  'List of equipment between a range of dates with answers to the questions asked when performing a service or inspection.': 'सेवा या निरीक्षण करते समय पूछे गए प्रश्नों के उत्तर के साथ विभिन्न तिथियों के बीच उपकरणों की सूची।',
  'List of Equipment for a site with important information such as last inspection date and next due service, highlighting equipment due for inspection in red.': 'किसी साइट के लिए उपकरणों की सूची जिसमें महत्वपूर्ण जानकारी जैसे अंतिम निरीक्षण तिथि और अगली देय सेवा, निरीक्षण के लिए देय उपकरणों को लाल रंग में उजागर करना।',
  'List of equipment that fits model search criteria. Example: a list of 5 pieces of equipment with model information matching 6LB ABC DRY.': 'मॉडल खोज मानदंडों पर फिट बैठने वाले उपकरणों की सूची। उदाहरण: 6LB ABC DRY से मेल खाने वाले मॉडल की जानकारी वाले 5 उपकरणों की सूची।',
  'Loading Equipment': 'उपकरण लोड हो रहा है',
  'Loading Models...': 'मॉडल लोड हो रहे हैं...',
  'Loading Scheduled Services...': 'शेड्यूल की गई सेवाएँ लोड हो रही हैं...',
  'Loading Scheduled Sites': 'अनुसूचित साइटें लोड हो रही हैं',
  'Loading Service Types...': 'सेवा प्रकार लोड हो रहे हैं...',
  'Loading Sites': 'साइटें लोड हो रही हैं',
  'Loading Unscheduled Services...': 'अनिर्धारित सेवाएँ लोड हो रही हैं...',
  'Loading...': 'लोड हो रहा है...',
  'Location': 'स्थान',
  'Logging in...': 'लॉग इन हो रहा है...',
  'Login Failed': 'लॉगिन विफल',
  'Login': 'लॉग इन करें',
  'Logout': 'लॉगआउट करें',
  'March': 'मार्च',
  'May': 'मई',
  'Meter Based Condition': 'मीटर आधारित स्थिति',
  'Model Deleted': 'मॉडल हटा दिया गया',
  'Model Field Information': 'मॉडल फ़ील्ड सूचना',
  'Model fields allow you to describe and report on equipment such as "Size", "Type" and "Category".': 'मॉडल फ़ील्ड आपको "आकार", "प्रकार" और "श्रेणी" जैसे उपकरणों का वर्णन और रिपोर्ट करने की अनुमति देते हैं।',
  'Model Fields': 'मॉडल फ़ील्ड',
  'Model Information': 'मॉडल सूचना',
  'Model Name': 'मॉडल का नाम',
  'Models allow quickly adding information to equipment such as which equipment type/services belong to it.': 'मॉडल उपकरण में त्वरित र��प से जानकारी जोड़ने की अनुमति देते हैं जैसे कि कौन सा उपकरण प्रकार/सेवाएँ उससे संबंधित हैं।',
  'Models': 'मॉडल',
  'Months of History (to start of month)': 'इतिहास के महीने (महीने की शुरुआत तक)',
  'More Details': 'अधिक विवरण',
  'Name': 'नाम',
  'Nevermind': 'कोई बात नहीं',
  'No Custom Equipment Fields': 'कोई कस्टम उपकरण फ़ील्ड नहीं',
  'No Deficiencies': 'कोई कमी नहीं',
  'No Equipment Fields': 'कोई उपकरण फ़ील्ड नहीं',
  'No Equipment Types': 'कोई उपकरण प्रकार नहीं',
  'No Equipment': 'कोई उपकरण नहीं',
  'No Floor Plans': 'कोई फ़्लोर योजना नहीं',
  'No History': 'कोई इतिहास नहीं',
  'No Model Fields': 'कोई मॉडल फ़ील्ड नहीं',
  'No Models': 'कोई मॉडल नहीं',
  'No Open Deficiencies': 'कोई खुली कमी नहीं',
  'No Open or Closed Issues': 'कोई खुला या बंद मुद्दा नहीं',
  'No overrides for this Site': 'इस साइट के लिए कोई ओवरराइड नहीं',
  'No Questions': 'कोई प्रश्न नहीं',
  'No Scheduled Services': 'कोई अनुसूचित सेवाएँ नहीं',
  'No Scheduled Sites': 'कोई अनुसूचित साइटें नहीं',
  'No Service Month Categories': 'कोई सेवा माह श्रेणियाँ नहीं',
  'No Service Types': 'कोई सेवा प्रकार नहीं',
  'No Site Fields': 'कोई साइट फ़ील्ड नहीं',
  'No Site Types': 'कोई साइट प्रकार नहीं',
  'No Sites': 'कोई साइट नहीं',
  'No Unscheduled Services': 'कोई अनिर्धारित सेवा नहीं',
  'No, Go Back': 'नहीं, वापस जाओ',
  'No': 'नहीं',
  'Not in at the time of inspection': 'निरीक्षण के समय नहीं आये',
  'Nothing to Inspect': 'निरीक्षण करने के लिए कुछ भी नहीं',
  'Nothing to Service': 'सेवा के लिए कुछ भी नहीं',
  'November': 'नवंबर',
  'October': 'अक्टूबर',
  'Ok': 'ठीक है',
  'Open a deficiency by clicking the plus in the top right of the pane. When the issue has been resolved, click on it and set the closed date.': 'फलक के शीर्ष दाईं ओर प्लस पर क्लिक करके कमी खोलें। जब समस्या हल हो जाए, तो उस पर क्लिक करे�� और समापन तिथि निर्धारित करें।',
  'Open a deficiency by tapping Options > Add Deficiency': 'विकल्प > कमी जोड़ें पर टैप करके कमी खोलें',
  'Open Deficiencies': 'खुली कमियाँ',
  'Open Deficiency': 'खुली कमी',
  'Open in Apple Maps': 'एप्पल मैप्स में खोलें',
  'Open in Google Maps': 'Google मानचित्र में खोलें',
  'Open Settings': 'सेटिंग्स खोलें',
  'Open': 'खुला',
  'Optional: Add a deficiency if this option is selected.': 'वैकल्पिक: यदि यह विकल्प चुना गया है तो एक कमी जोड़ें।',
  'Optional: This can be useful to set meter values easily': 'वैकल्पिक: यह मीटर मान आसानी से सेट क���ने के लिए उपयोगी हो सकता है',
  'Organization': 'संगठन',
  'Outstanding Equipment': 'उत्कृष्ट उपकरण',
  'PDF': 'पीडीएफ',
  'Perform From Now': 'अभी से प्रदर्शन करें',
  'Perform From Scheduled': 'शेड्यूल से प्रदर्शन करें',
  'Perform Service From Scheduled': 'शेड्यूल से सेवा निष्पादित करें',
  'Perform Service': 'सेवा करना',
  'Perform': 'प्रदर्शन करें',
  'Phone Number': 'फ़ोन नंबर',
  'Please fill out all fields': 'कृपया सभी फ़ील्ड भरें',
  'Please give a reason': 'कृपया कोई कारण बताएं',
  'Please select country first': 'कृपया पहले द��श चुनें',
  'Popup Note': 'पॉपअप नोट',
  'Preferences': 'प्राथमिकताएँ',
  'Preview Details': 'पूर्वावलोकन विवरण',
  'Profile': 'प्रोफाइल',
  'Purchase Barcodes': 'बारकोड खरीदें',
  'Question Deleted': 'प्रश्न हटा दिया गया',
  'Question Information': 'प्रश्न जानकारी',
  'Questionnaire Report': 'प्रश्नावली रिपोर्ट',
  'Questions': 'प्रश्न',
  'Range End': 'सीमा समाप्ति',
  'Range Start': 'रेंज प्रारंभ',
  'Reactivate': 'पुनः सक्रिय करें',
  'Remove': 'हटाओ',
  'Replace Barcode': 'बारकोड बदलें',
  'Replace Equipment': 'उपकरण बदलें',
  'Replaced equipment': 'बदले गए उपकरण',
  'Report Date': 'रिपोर्ट दिनांक',
  'Reports': 'रिपोर्ट',
  'Save time and minimize risk by plotting the location of equipment on a floor plan of this site': 'इस साइट के फ्लोर प्लान पर उपकरण का स्थान अंकित करके समय बचाएं और जोखिम कम करें',
  'Save': 'सहेजें',
  'Saving': 'सहेजा जा रहा है',
  'Scan barcode to make changes': 'परिवर्तन करने के लिए बारकोड को स्कैन करें',
  'Scan Barcode': 'बारकोड स्कैन करें',
  'Scan': 'स्कैन करें',
  'Schedule': 'अनुसूची',
  'Scheduled Event': 'निर्धारित कार्यक्रम',
  'Scheduled service definitions can be added to the equipment type in settings > equipment types': 'शेड्यूल की गई सेवा परिभाषाओं को सेटिंग > उपकरण प्रकार में उपकरण प्रकार में जोड़ा जा सकता है',
  'Scheduled': 'अनुसूचित',
  'See More': 'और देखें',
  'Selecting an option will add a history record and remove it from the todo list': 'एक विकल्प का चयन करने से एक इतिहास रिकॉर्ड जुड़ जाएगा और इसे कार्य सूची से हटा दिया जाएगा',
  'Selective Equipment Report': 'चयनात्मक उपकरण रिपोर्ट',
  'September': 'सितम्बर',
  'Service Due': 'सेवा देय',
  'Service month categories allow you to keep different types of equipment in different months. For example, you could inspect fire extinguishers in August and May and alarms in October.': 'सेवा माह श्रेणियां आपको विभिन्न महीनों में विभिन्न प्रकार के उपकरण रखने की अनुमति देती हैं। उदाहरण के लिए, आप अगस्त और मई में अग्निशामक यंत्रों और अक्टूबर में अलार्म का निरीक्षण कर सकते हैं।',
  'Service Month Categories': 'सेवा माह श्रेणियाँ',
  'Service Month Category': 'सेवा माह श्रेणी',
  'Service Month': 'सेवा माह',
  'Service months allow you to keep different types of equipment in selected months for each site. Example: Alarms in May and October and Extinguishers in December.': 'सेवा माह आपको प्रत्येक साइट के लिए चयनित महीनों में विभिन्न प्रकार के उपकरण रखने की अनुमति देते हैं। उदाहरण: मई और अक्टूबर में अलार्म और दिसंबर में बुझाने वाले उपकरण।',
  'Service Months': 'सेवा माह',
  'Service overrides allow you to disable a service or change the frequency for a specific site': 'सेवा ओवरराइड आपको किसी सेवा को अक्षम करने या किसी विशिष्ट साइट के लिए आवृत्ति बदलने की अनुमति देता है',
  'Service Type Settings': 'सेवा प्रकार सेटिंग्स',
  'Service Type': 'सेवा प्रकार',
  'Service Types': 'सेवा के प्रकार',
  'Service': 'सेवा',
  'Services are up to date': 'सेवाएँ अद्यतित हैं',
  'Services': 'सेवाएँ',
  'Set answer to equipment field': 'उपकरण क्षेत्र में उत्तर सेट करें',
  'Settings': 'सेटिंग्स',
  'Show Advanced': 'उन्नत दिखाएँ',
  'Show History Time': 'इतिहास का समय दिखाएँ',
  'Show Inspections': 'निरीक्षण दिखाएँ',
  'Show Questions / Answers': 'प्रश्न/उत्तर दिखाएं',
  'Show Services': 'सेवाएँ दिखाएँ',
  'Sign Up': 'साइन अप करें',
  'Simulate Scan': 'स्कैन का अनुकरण करें',
  'Site Deleted': 'साइट हटा दी गई',
  'Site Field Information': 'साइट फ़ील्ड जानकारी',
  'Site fields will allow you to enter additional information into the site, such as "Parking Location".': 'साइट फ़ील्ड आपको साइट में अतिरिक्त जानकारी दर्ज करने की अनुमति देगी, जैसे "पार्किंग स्थान"।',
  'Site Fields': 'साइट फ़ील्ड',
  'Site Information': 'साइट की जानकारी',
  'Site Report': 'साइट रिपोर्ट',
  'Site Reports': 'साइट रिपोर्ट',
  'Site Service Override': 'साइट सेवा ओवरराइड',
  'Site Service Overrides': 'साइट सेवा ओवरराइड',
  'Site Service Settings': 'साइट सेवा सेटिंग्स',
  'Site Settings': 'साइट सेटिंग्स',
  'Site Type': 'साइट का प्रकार',
  'Site types allow you to change service types based on the site. For example, only monthly customers would show the monthly inspection.': 'साइट प्रकार आपको साइट के आधार पर सेवा प्रकार बदलने की अनुमति देते हैं। उदाहरण के लिए, केवल मासिक ग्राहक ही मासिक निरीक्षण दिखाएंगे।',
  'Site types allow you to have different service types at different types of sites. For example, you may have to do monthly inspections at one site and only an annual inspection at another.': 'साइट प्रकार आपको विभिन्न प्रकार की साइटों पर वि���िन्न सेवा प्रकार की अनुमति देते हैं। उदाहरण के लिए, आपको एक साइट पर मासिक निरीक्षण करना पड़ सकता है और दूसरे पर केवल वार्षिक निरीक्षण करना पड़ सकता है।',
  'Site Types': 'साइट के प्रकार',
  'Sites can help you organize equipment into places such as "Office" or "Warehouse". If you run a servicing company, you can add your clients as sites. ': 'साइटें आपको उपकरण को "कार्यालय" या "वेयरहाउस" जैसी जगहों पर व्यवस्थित करने में मदद कर सकती हैं। यदि आप एक सर्विसिंग कंपनी चलाते हैं, तो आप अपने ग्राहकों को साइटों के रूप में जोड़ सकते हैं। ',
  'Sites': 'साइटें',
  'Start Date': 'आरंभ तिथि',
  'Start Trial': 'परीक्षण प्रारंभ करें',
  'Status': 'स्थिति',
  'Summary of services at a site separated by model information. Example 5 Monthly Inspections with model information 6LB DRY ABC.': 'मॉडल जानकारी द्वारा अलग की गई साइट पर सेवाओं का सारांश। उदाहरण 5 मॉडल जानकारी 6एलबी ड्राई एबीसी के साथ मासिक निरीक्षण।',
  'Swap Equipment': 'उपकरण बदलें',
  'Swapped equipment': 'उपकरण की अदला-बदली की गई',
  'TEST': 'परीक्षण',
  'The EMS plan is a discounted plan for non-profit or publicly funded emergency services.  Please choose another plan if you do not match this criteria': 'ईएमएस योजना गैर-लाभकारी या सार्वजनिक रूप से वित्त पोषित स्वास्थ्य सेवाओं के लिए एक रियायती योजना है।  यदि आप इस मानदंड से मेल नहीं खाते हैं तो कृपया कोई अन्य योजना चुनें',
  'The popup note is used to remind you of important information regarding the location. It will appear when opening the location screen.': 'पॉपअप नोट का उपयोग आपको स्थान के संबंध में महत्वपूर्ण जानकारी याद दिलाने के लिए किया जाता है। लोकेशन स्क्रीन खोलने पर यह दिखाई देगा।',
  'There are no unscheduled sites with outstanding inspections, service or deficiencies.': 'उत्कृष्ट निरीक्षण, सेवा या कमियों वाली कोई अनिर्धारित साइट नहीं हैं।',
  'There is no equipment at this site with this search criteria and due inspections': 'इस खोज मानदंड और उचित निरीक्षण के साथ इस साइट पर कोई उपकरण नहीं है',
  'There is no equipment at this site with this search criteria and due service': 'इस खोज मानदंड और उचित सेवा के साथ इस साइट पर कोई उपकरण नहीं है',
  'This Month': 'इस महीने',
  'Time at Site Detailed': 'साइट पर समय विस्तृत',
  'Time at Site': 'साइट पर समय',
  'Time Based Condition': 'समय आधारित स्थिति',
  'Today': 'आज',
  'Transfer Equipment': 'स्थानांतरण उपकरण',
  'Unscheduled service definitions can be added to the equipment type in settings > equipment types': 'सेटिंग्स > उपकरण प्रकार में उपकरण प्रकार में अनिर्धारित सेवा परिभाषाएँ जोड़ी जा सकती हैं',
  'Unscheduled': 'अनिर्धारित',
  'Updated barcode': 'अद्यतन बारकोड',
  'Used Equipment SKU': 'प्रयुक्त उपकरण SKU',
  'Used for the billing export for new, swapped and replaced equipment.': 'नए, बदले गए और बदले गए उपक���णों के बिलिंग निर्यात के लिए उपयोग किया जाता है।',
  'User Deleted': 'उपयोगकर्ता हटा दिया गया',
  'User Information': 'उपयोगकर्ता जानकारी',
  'User': 'उपयोगकर्ता',
  'Users': 'उपयोगकर्ता',
  'View on FloorPlan': 'फ़्लोरप्लान पर देखें',
  'View Terms': 'शर्तें देखें',
  'Whenever equipment is swapped the billing export will increment the quantitiy under this SKU.': 'जब भी उपकरण की अदला-बदली की जाती है तो बिलिंग निर्यात इस SKU के तहत मात्रा में वृद्धि करेगा।',
  'Yes, Delete Equipment Field': 'हाँ, उपकरण फ़ील्ड हटाएँ',
  'Yes, Delete Equipment Type': 'हाँ, उपकरण प्रकार हटाएँ',
  'Yes, Delete Equipment': 'हाँ, उपकरण हटाएँ',
  'Yes, Delete Floor Plan': 'हाँ, फ़्लोर प्लान हटाएँ',
  'Yes, Delete Model Field': 'हाँ, मॉडल फ़ील्ड हटाएँ',
  'Yes, Delete Model': 'हाँ, मॉडल हटाएँ',
  'Yes, Delete Question': 'हां, प्रश्न हटाएं',
  'Yes, Delete Record': 'हां, रिकॉर्ड हटाएं',
  'Yes, Delete Service Month': 'हाँ, सेवा माह हटाएँ',
  'Yes, Delete Service Type': 'हाँ, सेवा प्रकार हटाएँ',
  'Yes, Delete Site Field': 'हाँ, साइट फ़ील्ड हटाएँ',
  'Yes, Delete Site Type': 'हाँ, साइट प्रकार हटाएँ',
  'Yes, Delete Site': 'हां, साइट हटाएं',
  'Yes, Delete User': 'हां, उपयोगकर्ता हटाएं',
  'Zone': 'जोन',
  'Customer': 'ग्राहक',
  'Site': 'साइट',
  'All Sites': 'सभी साइटें',
  'Loading Customers': 'ग्राहक लोड हो रहे हैं',
  'No Customers': 'कोई ग्राहक नहीं',
  'Add Customer': 'ग्राहक जोड़ें',
  'Customers are groups of sites with billing information.': 'ग्राहक बिलिंग जानकारी वाली साइटों के समूह हैं।',
  'Customers': 'ग्राहक',
  'Customer Information': 'ग्राहक सूचना',
  'Delete Customer': 'ग्राहक हटाएँ',
  'Yes, Delete Customer': 'हां, ग्राहक हटाएं',
  'Delete Customer?': 'ग्राहक हटाएं?',
  'Customer Deleted': 'ग्राहक हटा दिया गया',
  'Create Customer': 'ग्राहक बनाएं',
  'Assign Existing Customer': 'मौजूदा ग्राहक को असाइन करें',
  'Edit Customer': 'ग्राहक संपादित करें',
  'Enter a serial number': 'एक क्रमांक दर्ज करें',
  'Remove Customer': 'ग्राहक को हटाएँ',
  'Find': 'खोजें',
  'Sync Now': 'अभी सिंक करें',
  'Syncing...': 'सिंक हो रहा है...',
  'Find equipment by serial number': 'क्रम संख्या के आधार पर उपकरण खोजें',
  'Last successful upload was {formattedDate}': 'अंतिम सफल अपलोड {formattedDate} था',
  'Up to date as of {formattedDate}': '{formattedDate} तक अद्यतित',
  'Zones are used to group locations in the location report': 'ज़ोन का उपयोग स्थान रिपोर्ट में स्थानों को समूहीकृत करने के लिए किया जाता है',

  'Account Number': 'खाता संख्या',
  'Add Location Override': 'स्थान ओवरराइड जोड़ें',
  'Add New Model': 'नया मॉडल जोड़ें',
  'Add Site Field': 'साइट फ़ील्ड जोड़ें',
  'Address Line 2': 'पता पंक्ति नं। 2',
  'Agree to': 'करने के लिए सहमत है',
  'All conditions are true': 'सभी स्थितियाँ सत्य हैं',
  'All Permissions': 'सभी अनुमतियाँ',
  'Allow Text Input': 'टेक्स्ट इनपुट की अनुमति दें',
  'An email with the reset password link below has been sent to': 'नीचे रीसेट पासवर्ड लिंक वाला एक ईमेल भेजा गया है',
  'An error ocurred while trying to show this page.': 'इस पृष्ठ को दिखाने का प्रयास करते समय एक त्रुटि उत्पन्न हुई.',
  'Any condition is true': 'कोई भी शर्त सत्य है',
  'Background Color': 'पृष्ठभूमि का रंग',
  'Billing and customer controls': 'बिलिंग और ग्राहक नियंत्रण',
  'Building Reports - Safety Scan': 'बिल्डिंग रिपोर्ट - सुरक्षा स्कैन',
  'Change Another Service': 'अन्य सेवा बदलें',
  'Choose Site': 'साइट चुनें',
  'click here': 'यहाँ क्लिक करें',
  'Closed Date': 'समापन तिथि',
  'Closed Deficiencies': 'बंद कमियाँ',
  'Company Information': 'कारखाना की जानकारी',
  'Company Name': 'कंपनी का नाम',
  'Completing Sign Up': 'साइन अप पूरा करना',
  'Context ID': 'प्रसंग आईडी',
  'Could not find equipment with that barcode': 'उस बारकोड वाले उपकरण नहीं मिल सके',
  'Creating invite link...': 'आमंत्रण लिंक बनाया जा रहा है...',
  'Current equipment failed to load': 'वर्तमान उपकरण लोड करने में विफल रहे',
  'Data File': 'डेटा फाइल',
  'Data Origin': 'डेटा उत्पत्ति',
  'Date affected by': 'दिनांक से प्रभावित',
  'Date Completed': 'दिनांक संपन्न',
  'Date Started': 'आरंभ तिथि',
  'Delete equipment?': 'उपकरण हटाएँ?',
  'Dev Environment': 'देव पर्यावरण',
  'Disabled For': 'के लिए अक्षम',
  'Disabled For Location': 'स्थान के लिए अक्षम',
  'Do not change': 'बदलें नहीं',
  'Due When': 'देय कब',
  'Edit Deficiencies': 'कमियाँ संपादित करें',
  'Edit History': 'इतिहास संपादित करें',
  'Edit Location': 'स्थान संपादित करें',
  'Edit Schedule': 'शेड्यूल संपादित करें',
  'Edit Service': 'सेवा संपादित करें',
  'Edit Settings': 'विन्यास बदलें',
  'End Time': 'अंत समय',
  'Equal to': 'के बराबर',
  'Equipment Field': 'उपकरण क्षेत्र',
  'Equipment replaced': 'उपकरण बदला गया',
  'Equipment swapped': 'उपकरण की अदला-बदली की गई',
  'Example: Broken Handle': 'उदाहरण: टूटा हुआ हैंडल',
  'Frequency Type': 'आवृत्ति प्रकार',
  'Generate Reports': 'रिपोर्ट तैयार करें',
  'Get started by checking out our tutorials on YouTube or setting up your account in settings.': 'YouTube पर हमारे ट्यूटोरियल देखकर या सेटिंग्स में अपना खाता सेट करके शुरुआत करें।',
  'Global Search': 'वैश्विक खोज',
  'Greater than': 'से अधिक',
  'hasn&apos;t accepted their invite yet. You can': 'ने अभी तक उनका निमंत्रण स्वीकार नहीं किया है. ',
  'Include In Reports': 'रिपोर्ट में शामिल करें',
  'landscape LetterHead': 'लैंडस्केप लेटरहेड',
  'Last Date': 'अंतिम तिथि',
  'Last Date Minimum Granularity': 'अंतिम तिथि न्यूनतम ग्रैन्युलैरिटी',
  'Last Download': 'अंतिम डाउनलोड',
  'Last Upload': 'अंतिम अपलोड',
  'Less than': 'से कम',
  'Locations can only be added on a desktop browser': 'स्थान केवल डेस्कटॉप ब्राउज़र पर ही जोड़े जा सकते हैं',
  'Looks like you never finished signing up': 'ऐसा लगता है कि आपने साइन अप कभी पूरा नहीं किया',
  'Metered Condition': 'पैमाइश की स्थिति',
  'Mobile Access': 'मोबाइल एक्सेस',
  'Model Number': 'मॉडल नंबर',
  'Next Date (Overide)': 'अगली तिथि (ओवरराइड)',
  'No Conditions': 'कोई शर्त नहीं',
  'No Options': 'कोई विकल्प नहीं',
  'Not equal to': 'असमान',
  'Opened Date': 'खुलने की तिथि',
  'Option Selected': 'विकल्प चयनित',
  'Perform On Scan': 'स्कैन पर प्रदर्शन करें',
  'Please click the button below to start your free 3 month trial': 'कृपया अपना निःशुल्क 3 महीने का परीक्षण शुरू करने के लिए नीचे दिए गए बटन पर क्लिक करें',
  'Please review the terms below': 'कृपया नीचे दी गई शर्तों की समीक्षा करें',
  'Portrait LetterHead': 'पोर्ट्रेट लेटरहेड',
  'Postal Code': 'डाक कोड',
  'Powered By': 'द्वारा संचालित',
  'Preventive Maintenance': 'निवारक रखरखाव',
  'Profile Image': 'प्रोफ़ाइल छवि',
  'Receive marketing emails': 'मार्केटिंग ईमेल प्राप्त करें',
  'Rivison Inc.': 'रिविज़न इंक.',
  'Search Sites...': 'साइटें खोजें...',
  'Serial Number': 'क्रम संख्या',
  'Service is Unscheduled': 'सेवा अनिर्धारित है',
  'Service Options': 'सेवा विकल्प',
  'Service or Inspection Due': 'सेवा या निरीक्षण देय',
  'Show All': 'सब दिखाएं',
  'Show site selector in top corner': 'शीर्ष कोने में साइट चयनकर्ता दिखाएँ',
  'Sign-Up Failed. Ensure the email is not already is use.': 'साइन अप करने में विफल रहा। ',
  'Sorry, an error occurred while trying to create an invite link. Please try again later, or reach out to support': 'क्षमा करें, आमंत्रण लिंक बनाने का प्रयास करते समय एक त्रुटि उत्पन्न हुई। ',
  'Sorry, looks like you&apos;re offline. Please try again when you have an internet connection': 'क्षमा करें, ऐसा लगता है कि आप ऑफ़लाइन हैं। ',
  'Start Time': 'समय शुरू',
  'Successfully updated profile': 'प्रोफ़ाइल सफलतापूर्वक अपडेट की गई',
  'terms and conditions': 'नियम और शर्तें',
  'Text Input': 'पाठ इनपुट',
  'The date below is used to show history records only.': 'नीचे दी गई तारीख का उपयोग केवल इतिहास के रिकॉर्ड दिखाने के लिए किया जाता है।',
  'This will just take a moment': 'इसमें बस एक क्षण लगेगा',
  'Time Condition': 'समय की स्थिति',
  'Time Zone': 'समय क्षेत्र',
  'to generate another invite link.': 'एक और आमंत्रण लिंक उत्पन्न करने के लिए।',
  'Toggle Flashlight': 'टॉर्च टॉगल करें',
  'Type more characters to narrow the search further': 'खोज को और अधिक सीमित करने के लिए अधिक अक्षर टाइप करें',
  'Use text answer for': 'के लिए टेक्स्ट उत्तर का उपयोग करें',
  'Version:': 'संस्करण:',
  'View Deficiencies': 'कमियाँ देखें',
  'View Equipment': 'उपकरण देखें',
  'View History': 'इतिहास देखें',
  'View Location': 'स्थान देखें',
  'View Schedule': 'शेड्यूल देखें',
  'View Service': 'सेवा देखें',
  'View Settings': 'सेटिंग्स देखें',
  'We hope to see you again.': 'फिर मिलेंगे।',
  'Web Login': 'वेब लॉगिन',
  'Welcome,': 'स्वागत,',
  'White Label': 'सफेद उपनाम',
  'Work Day End Time': 'कार्य दिवस समाप्ति समय',
  'Work Day Start Time': 'कार्य दिवस प्रारंभ समय',
  'You must agree to the terms and conditions': 'आपको नियम और शर्तों से सहमत होना होगा',
  'Your Subscription Has Been Canceled': 'आपकी सदस्यता रद्द कर दी गई है',
};
